/**
 * Module-level bridge decoupling the real-time global-stats consumer
 * (`useRealtimeStats`) from the socket that carries the deltas.
 *
 * Global stats deltas now ride the notifications SSE (Hub-only, gated server-side
 * on `app=hub`) as a `global.stats.delta` notification on the `message` event, so
 * Hub opens one app-shell socket instead of a dedicated `/hub/stats/sse`.
 * `useNotifications` owns that socket and forwards each delta here;
 * `useRealtimeStats` subscribes and folds it into the stats cache.
 */
export interface StatsDelta {
  volumeDelta: string;
  tradesDelta: number;
}

type StatsDeltaListener = (delta: StatsDelta) => void;

const listeners = new Set<StatsDeltaListener>();

/** Notifications SSE → a `global.stats.delta` frame arrived. */
export const emitStatsDelta = (delta: StatsDelta): void => {
  for (const listener of listeners) listener(delta);
};

export const subscribeToStatsDeltas = (listener: StatsDeltaListener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
